export enum MixpanelEvents {
	PAGE_VIEWED = 'page_viewed',
	FORM_SELLING_CLICKED = 'form_selling_clicked',
	FORM_OFF_MARKET_CLICKED = 'form_off_market_clicked',
	FORM_PROPERTY_VIEWED = 'form_property_viewed',
	FORM_PROPERTY_CLICKED = 'form_property_clicked',
	FORM_PROPERTY_INITIATED = 'form_property_initiated',
	FAQ_CLICKED = 'faq_clicked',
	BREADCRUMB_CLICKED = 'breadcrumb_clicked',
	LINK_CLICKED = 'link_clicked',
	CTA_VIEW_MORE_CLICKED = 'cta_view_more_clicked',
	FORM_BROKER_CLICKED = 'form_broker_clicked',
	CARD_NEIGHBORHOOD_CLICKED = 'card_neighborhood_clicked',
	MAP_LISTING_CLICKED = 'map_listing_clicked',
	LOGIN_OPENED = 'login_opened',
	LOGIN_PHONE = 'login_phone',
	LOGIN_AUTHENTICATION = 'login_authentication',
	THERMS_CLICKED = 'terms_clicked',
	CLOSE_CLICKED = 'close_clicked',
	RETURN_CLICKED = 'return_clicked',
	SIGNUP_COMPLETED = 'signup_completed',
	MAP_LISTING_INTERACTED = 'map_listing_interacted',
	CARD_CLICKED = 'card_clicked',
	CONDO_CARD_CLICKED = 'condo_card_clicked',
	CARD_IMAGE_SCROLLED = 'card_image_scrolled',
	TOKEN_RESEND_CLICK = 'token_resend_click',
	FORM_PROPERTY_AUTHENTICATION = 'form_property_authentication',
	FORM_PROPERTY_COMPLETED = 'form_property_completed',
	FORM_PROPERTY_ERROR = 'form_property_error',
	HEADER_CLICKED = 'header_clicked',
	MENU_HEADER_CLICKED = 'menu_header_clicked',
	FILTERS_CLEARED = 'filters_cleared',
	EMPTY_STATE_FILTER = 'empty-state_filter',
	FILTER_BY_SUGGEST = 'filter_by_suggest',
	FILTER_APPLIED = 'filter_applied',
	SEARCH_HISTORY_FILTER = 'search-history_filter',
	REGION_NAME = 'region_name',
	CITY_NAME = 'city_name',
	SUGGESTION_CLICKED = 'suggestion_clicked',
	SUGGESTION_POSITION = 'suggestion_position',
	OTHER_SUGGESTIONS = 'other_suggestions',
	TOTAL_RESULTS = 'total_results',
	REORDER_CLICKED = 'reorder_clicked',
	MENU_PROPERTY_CLICKED = 'menu_property_clicked',
	MENU_COLLECTION_CLICKED = 'menu_collection_clicked',
	SHARE_PROPERTY_CLICKED = 'share_property_clicked',
	EMPTY_STATE = 'empty_state',
	CARD_HERO_OPENED = 'card_hero_opened',
	CTA_OFF_MARKET_CLICKED = 'cta_off_market_clicked',
	CAROUSEL_NEIGHBORHOOD_CLICKED = 'carousel_neighborhood_clicked',
	MAP_PROPERTY_OPENED = 'map_property_opened',
	MODAL_PHOTO_OPENED = 'modal_photo_opened',
	MODAL_VIDEO_OPENED = 'modal_video_opened',
	CTA_HOME_CLICKED = 'cta_home_clicked',
	CARD_COLLECTION_CLICKED = 'card_collection_clicked',
	PAGE_ERROR = 'page_error',
	COOKIES_ACCEPTED = 'cookies_accepted',
	TAB_NEIGHBORHOOD_CLICKED = 'tab_neighborhood_clicked',
	CAR_NEIGHBORHOOD_CLICKED = 'card_neighborhood_clicked',
	IDENTITY_MERGE = 'identity_merge',
	SHARE_CONDO_CLICKED = 'share_condo_clicked',
	MENU_CONDO_CLICKED = 'menu_condo_clicked',
	SELECTION_CLEARED = 'selection_cleared',
	BOUNDARIES_CLEARED = 'boundaries_cleared',
	SEARCH_BAR_CLICKED = 'search_bar_clicked',
	COMMERCIAL_ID_COPIED = 'commercial_id_copied',
	CTA_SIMILAR_PROPERTIES_CLICKED = 'cta_similar_properties_clicked',
	PROPERTY_FAVORITED = 'property_favorited',
	SHARE_COLLECTION_CLICKED = 'share_collection_clicked',
	LOGOUT_COMPLETED = 'logout_completed',
	CTA_PROFILE_CLICKED = 'cta_profile_clicked',
	PROFILE_UPDATED = 'profile_updated',
	REGION_CARD_CLICKED = 'card_region_clicked',
	CARD_FEATURE_CLICKED = 'card_feature_clicked',
	SHORTS_VIEWED_ENTRY = 'shorts_viewed_entry',
	SHORTS_VIEWED_EXIT = 'shorts_viewed_exit'
}

export enum MixpanelProps {
	CURRENT_PAGE = 'current_page',
	PREVIOUS_PAGE_URL = 'previous_page_url',
	EVENT_NAME = 'event_name',
	CTA_TEXT = 'cta_text',
	USER_NAME = 'user_name',
	USER_EMAIL = 'user_email',
	USER_PHONE = 'user_phone',
	USER_ACTION = 'user_action',
	LOGIN_TYPE = 'login_type',
	SECTION_NAME = 'section_name',
	QUESTION_TEXT = 'question_text',
	QUESTION_POSITION = 'question_position',
	DESTINATION_URL = 'destination_url',
	COLLECTION_NAME = 'collection_name',
	CLICK_HOME = 'click_home',
	CLICK_MACROREGION = 'click_macroregion',
	CLICK_STREET = 'click_street',
	CLICK_STATE = 'click_state',
	LINK_CATEGORY = 'link_category',
	LINK_TEXT = 'link_text',
	CURRENT_NEIGHBORHOD = 'current_neighborhood',
	DESTINATION_NEIGHBORHOOD = 'destination_neighborhood',
	CLICK_LOCATION = 'click_location',
	FILTER_NEIGHBORHOOD = 'filter_neighborhood',
	FILTER_REGION = 'filter_region',
	FILTER_CITY = 'filter_city',
	CLICK_LOGIN = 'click_login',
	PRIVACY_POLICY = 'privacy_policy',
	TERMS_OF_USE = 'terms_of_use',
	CURRENT_FLOW = 'current_flow',
	CURRENT_STEP = 'current_step',
	CLICK_SQUARE = 'click_square',
	SQUARE_COUNT = 'square_count',
	PROPERTY_COUNT = 'property_count',
	CARD_POSITION = 'card_position',
	CARD_TYPE = 'card_type',
	CARD_TEXT = 'card_text',
	PHOTO_URL = 'photo_url',
	PHOTO_POSITION = 'photo_position',
	TAG_EXCLUSIVE = 'tag_exclusive',
	CLICK_COUNT = 'click_count',
	ATTEMPT_COUNT = 'attempt_count',
	ASKING_PRICE = 'asking_price',
	COMMERCIAL_ID = 'commercial_id',
	PAGE_URL = 'page_url',
	COMPANY_NAME = 'company_name',
	AGENT_NAME = 'agent_name',
	INPUT_NAME = 'input_name',
	INPUT_PHONE = 'input_phone',
	INPUT_EMAIL = 'input_email',
	INPUT_MESSAGE = 'input_message',
	ACCOUNT_STATUS = 'account_status',
	ERROR_TYPE = 'error_type',
	ERROR_CODE = 'error_type',
	USER_STATUS = 'user_status',
	CLICK_FOOTER = 'click_footer',
	CLICK_FORM = 'click_form',
	UPDATED_NAME = 'updated_name',
	UPDATED_EMAIL = 'updated_email',
	CLICK_LOGO = 'click_logo',
	CLICK_BUY = 'click_buy',
	CLICK_SELL = 'click_sell',
	CLICK_ABOUT_PILAR = 'click_about_pilar',
	CLICK_OPTION = 'click_option',
	CLICK_OFF_MARKET = 'click_off_market',
	CLICK_EXCLUSIVE = 'click_exclusive',
	CLICK_SHORTS = 'click_shorts',
	CLICK_OWNER = 'click_owner',
	CLICK_FORMER = 'click_former',
	CLICK_REGION = 'click_region',
	CLICK_NEIGHBORHOOD = 'click_neighborhood',
	CLICK_CITY = 'click_city',
	REGION_NAME = 'region_name',
	NEIGHBORHOOD_NAME = 'neighborhood_name',
	CLICK_HIGHLIGHTS = 'click_highlights',
	CLICK_EXCLUSIVES = 'click_exclusives',
	CLICK_LOWEST_PRICE = 'click_lowest_price',
	CLICK_HIGHEST_PRICE = 'click_highest_price',
	CLICK_FEWER_PHOTOS = 'click_fewer_photos',
	CLICK_OVERVIEW = 'click_overview',
	CLICK_ATTRIBUTES = 'click_attributes',
	CLICK_SERVICE = 'click_service',
	CLICK_NEIGHBORHOOD_TAB = 'click_neighborhood_tab',
	CLICK_NEIGHBORHOOD_CARD = 'click_neighborhood_card',
	CLICK_NEIGHBORHOOD_TITLE = 'click_neighborhood_title',
	CLICK_CARD = 'click_card',
	CLICK_MAP = 'click_map',
	SHARE_WHATSAPP = 'share_whatsapp',
	SHARE_FACEBOOK = 'share_facebook',
	COPY_LINK = 'copy_link',
	SHARE_EMAIL = 'share_email',
	SHARE_INSTAGRAM = 'share_instagram',
	SHARE_TWITTER = 'share_twitter',
	SHARE_CLICKED = 'share_clicked',
	EMPTY_TYPE = 'empty_type',
	PROPERTIES_COUNT = 'properties_count',
	FILTER_AREA = 'filter_area',
	FILTER_IPTU = 'filter_iptu',
	FILTER_PRICE = 'filter_price',
	FILTER_TYPOLOGY = 'filter_typology',
	FILTER_BATHROOMS = 'filter_bathrooms',
	FILTER_GARAGE = 'filter_garage',
	FILTER_SUITES = 'filter_suites',
	FILTER_EXCLUSIVES = 'filter_exclusives',
	FILTER_BEDROOMS = 'filter_bedrooms',
	FILTER_ATTRIBUTES = 'filter_attributes',
	CLICK_MORE_PHOTOS = 'click_more_photos',
	CLICK_MORE_RELEVANT = 'click_more_relevant',
	CLICK_MORE_RECENT = 'click_more_recent',
	CLICK_OLDEST = 'click_oldest',
	TOTAL_RESULTS = 'total_results',
	PREVIOUS_RESULTS = 'previous_results',
	NEIGHBORHOODS_CLEARED = 'neighborhoods_cleared',
	PRICE_CLEARED = 'price_cleared',
	AREA_CLEARED = 'area_cleared',
	PROPERTY_TYPE_CLEARED = 'property_type_cleared',
	ROOMS_CLEARED = 'rooms_cleared',
	ATTRIBUTES_CLEARED = 'attributes_cleared',
	PRICE_PER_SQM_CLEARED = 'price_per_sqm_cleared',
	STATUS_CLEARED = 'status_cleared',
	IPTU_CLEARED = 'iptu_cleared',
	CONDO_FEE_CLEARED = 'condo_fee_cleared',
	CONDO_NAME = 'condo_name',
	TEXT_SEARCH = 'text_search',
	CITY_NAME = 'city_name',
	SUGGESTION_CLICKED = 'suggestion_clicked',
	SUGGESTION_POSITION = 'suggestion_position',
	OTHER_SUGGESTIONS = 'other_suggestions',
	OTHER_SUGGESTIONS_COUNT = 'other_suggestions_count',
	SUGGEST_CLICK = 'suggest_click',
	EMPTY_STATE_CLICK = 'empty_state_click',
	FILTERS_APPLIED = 'filters_applied',
	FILTERED_BY_OPEN_FILTERS = 'filtered_by_open_filters',
	FILTERED_BY_SEARCH_BAR = 'filtered_by_search_bar',
	FILTERED_BY_QUICK_FILTER = 'filtered_by_quick_filters',
	FILTERED_BY_MORE_FILTERS = 'filtered_by_more_filters',
	TEXT_SEARCHED = 'text_searched',
	NEIGHBORHOODS_NAME = 'neighborhoods_name',
	NEIGHBORHOODS_COUNT = 'neighborhoods_count',
	SEARCH_TERM = 'search_term',
	ADDRESS_OR_POINT_OF_INTEREST_NAME = 'address/point_of_interest_name',
	MIN_PRICE = 'min_price',
	MAX_PRICE = 'max_price',
	MIN_AREA = 'min_area',
	MAX_AREA = 'max_area',
	PROPERTY_TYPE = 'property_type',
	BEDROOMS = 'bedrooms',
	BATHROOMS = 'bathrooms',
	SUITES = 'suites',
	PARKING_SPOTS = 'parking_spots',
	ATTRIBUTES = 'attributes',
	MIN_PRICE_PER_SQM = 'min_price_per_sqm',
	MAX_PRICE_PER_SQM = 'max_price_per_sqm',
	STATUS = 'status',
	MIN_IPTU = 'min_iptu',
	MAX_IPTU = 'max_iptu',
	MIN_CONDO_FEE = 'min_condo_fee',
	MAX_CONDO_FEE = 'max_condo_fee',
	CLICK_PHOTO = 'click_photo',
	CLICK_CTA = 'click_cta',
	CLICK_EMPTY = 'click_empty',
	CLICK_VIDEO = 'click_video',
	PHOTO_COUNT = 'photo_count',
	VIDEO_URL = 'video_url',
	TAB_POSITION = 'tab_position',
	CLICK_EXCLUSIVITIES = 'click_exclusivities',
	CLICK_CONDO = 'click_condo',
	CLICK_SQUARES = 'click_squares',
	CLICK_BLOG = 'click_blog',
	CLICK_DISCOVER = 'click_discover',
	CLICK_NAME = 'click_name',
	CLICK_PHONE = 'click_phone',
	CLICK_EMAIL = 'click_email',
	CLICK_MESSAGE = 'click_message',
	ZOOM_CLICK = 'zoom_click',
	FINAL_CLICK = 'final_click',
	CLICK_CTA_FLOATING = 'click_cta_floating',
	CLICK_CTA_FIXED = 'click_cta_fixed',
	CLICK_CTA_CARD = 'click_cta_card',
	CLICK_LINK = 'click_link',
	CLICK_SIMILAR_PROPERTIES = 'click_similar_properties',
	CLICK_FAVORITE = 'click_favorite',
	CLICK_UNFAVORITE = 'click_unfavorite',
	CLICK_PROPERTY = 'click_property',
	CLICK_COLLECTION = 'click_collection',
	CLICK_USER_INFORMATION = 'click_user_information',
	CLICK_FIRST_FIELD = 'click_first_field',
	CLICK_SECOND_FIELD = 'click_second_field',
	CLICK_BUYER = 'click_buyer',
	FEATURE_NAME = 'feature_name',
	VIDEO_SHORTS = 'video_shorts',
	PHOTO_SHORTS = 'photo_shorts',
	SHORT_POSITION = 'short_position',
	SHORT_TYPE = 'short_type',
	INICIAL_COMMERCIAL_ID = 'inicial_commercial_id',
	INICIAL_ASKING_PRICE = 'inicial_asking_price',
	INICIAL_REGION_NAME = 'inicial_region_name',
	SCREEN_TIME = 'screen_time'
}

export enum MixpanelUserActionValues {
	SIGN_IN = 'sign in',
	SIGN_UP = 'sign up',
	SIGN_IN_UP = 'sign in/up'
}

export enum MixpanelLoginTypeValues {
	PHONE = 'celular',
	FACEBOOK = 'facebook',
	GOOGLE = 'google'
}
